import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {entitlementResourceChangeLogStateSelector} from './entitlement-resource-change-log-state.slice';

import type {EntitlementResourceLogsCriteria} from '../typedef';
import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {LogHits} from 'src/openapi/admin/models/LogHits';


export const entitlementResourceChangeLogSlice = getCachedTableDataSlice<
    LogHits[],
    undefined,
    undefined,
    EntitlementResourceLogsCriteria
>('entitlementResourceChangeLog');

export const entitlementResourceChangeLogActions = entitlementResourceChangeLogSlice.actions;
const entitlementResourceChangeLogCacheSelector: CachedTableCacheSelector<LogHits[]>
    = state => state.manageEntitlements.entitlementResourceChangeLogReducer.events.cache;
export const entitlementResourceChangeLogDataSelector: CachedTableDataSelector<LogHits[]>
    = state => state.manageEntitlements.entitlementResourceChangeLogReducer.events;
export const entitlementResourceChangeLogResultSelector = getCachedTableResultSelector(
    entitlementResourceChangeLogCacheSelector,
    entitlementResourceChangeLogStateSelector,
);
